import React, { useEffect, useRef, useState } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import { Button } from './ui/button';
import { X, Camera } from 'lucide-react';

/**
 * QR Scanner overlay for mobile.
 * Props:
 *   onScan(decodedText) — called with the scanned QR content
 *   onClose() — close the scanner
 */
const QRScanner = ({ onScan, onClose }) => {
  const scannerRef = useRef(null);
  const html5QrRef = useRef(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const scannerId = 'qr-reader-' + Date.now();
    if (scannerRef.current) {
      scannerRef.current.id = scannerId;
    }

    const html5Qr = new Html5Qrcode(scannerId);
    html5QrRef.current = html5Qr;

    html5Qr.start(
      { facingMode: 'environment' },
      { fps: 10, qrbox: { width: 250, height: 250 } },
      (decodedText) => {
        html5Qr.stop().catch(() => {});
        onScan(decodedText);
      },
      () => {}
    ).catch((err) => {
      setError('Camera access denied or not available');
      console.error('QR Scanner error:', err);
    });

    return () => {
      html5Qr.stop().catch(() => {});
    };
  }, [onScan]);

  return (
    <div className="fixed inset-0 z-50 bg-black/90 flex flex-col items-center justify-center" data-testid="qr-scanner-overlay">
      <div className="absolute top-4 right-4">
        <Button variant="ghost" size="icon" className="text-white hover:bg-white/20" onClick={onClose}>
          <X className="w-6 h-6" />
        </Button>
      </div>
      <p className="text-white text-sm mb-4 font-medium">Scan Parcel QR Code</p>
      <div
        ref={scannerRef}
        className="w-[300px] h-[300px] rounded-lg overflow-hidden"
      />
      {error && (
        <div className="mt-4 text-center">
          <p className="text-red-400 text-sm">{error}</p>
          <Button variant="outline" className="mt-2 text-white border-white/30" onClick={onClose}>
            Close
          </Button>
        </div>
      )}
      <p className="text-white/50 text-xs mt-4">Point camera at parcel QR code</p>
    </div>
  );
};

export default QRScanner;
